export const formatAccountAndAgency = (accountOrAgency: string) => {
  if (accountOrAgency.length > 0) {
    const formattedString =
      accountOrAgency.slice(0, -1) + '-' + accountOrAgency.slice(-1)
    return formattedString
  }

  return accountOrAgency
}
